var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useState } from "react";
import * as i18n from "@utils/langs/i18nUtils";
import { useRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useLocation, useNavigate } from "react-router-dom";
import { menu, url } from "@recoil/Store";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
export default function Header() {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const isDetail = params.has("detail"); //  detail 존재 여부    
    const [menus, setMenus] = useRecoilState(menu); // recoil userState
    const [urls, setUrl] = useRecoilState(url);
    const [side, setSide] = useState(false);
    const initialLang = (() => {
        try {
            const sp = new URLSearchParams(window.location.search);
            const q = (sp.get('lang') || '').toUpperCase();
            if (q === 'KOR' || q === 'ENG')
                return q;
            const ls = (localStorage.getItem(Const.LANG_TYPE) || '').toUpperCase();
            if (ls === 'KOR' || ls === 'ENG')
                return ls;
        }
        catch (_a) { }
        return 'KOR';
    })();
    const [lang, setLang] = useState(initialLang);
    let appPath = `?lang=${lang}`;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/menu/guest${appPath}`,
        appQuery: {},
        userToken: "",
        watch: appPath,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                let menus = data.body.map((item) => (Object.assign(Object.assign({}, item), { url: item.url ? item.url : item.subMenus[0].url })));
                let depth1 = null;
                let depth2 = null;
                setMenus(menus);
                if (location.pathname != "/main") {
                    // 1단계 루프
                    for (const main of menus) {
                        // 2단계가 존재한다면
                        if (main.subMenus) {
                            // 하위 중에서 현재 pathname과 일치하는 메뉴 찾기
                            const found = main.subMenus.find(sub => sub.url === location.pathname);
                            if (found) {
                                depth2 = found; // 현재 메뉴 (depth:2)
                                depth1 = main; // 상위 메뉴 (depth:1)
                                break;
                            }
                        }
                    }
                    setUrl({
                        depth1: depth1,
                        depth2: depth2
                    });
                }
                else {
                    setUrl(null);
                }
            }
        }
    }, [data]);
    useEffect(() => {
        try {
            const sp = new URLSearchParams(search);
            const q = (sp.get('lang') || '').toUpperCase();
            if (q === 'KOR' || q === 'ENG') {
                if (q !== lang) {
                    i18n.changeLang(q);
                    setLang(q);
                    localStorage.setItem(Const.LANG_TYPE, q);
                }
            }
        }
        catch (_a) { }
    }, [search]);
    // 다국어 변경 
    const langSelect = (e) => __awaiter(this, void 0, void 0, function* () {
        const param = e.target.value;
        const qs = new URLSearchParams(search);
        qs.set('lang', param);
        setLang(param);
        localStorage.setItem(Const.LANG_TYPE, param);
        navigate(`${pathname}?${qs.toString()}`, { replace: false });
        // 다국어 변경 시 기존 메뉴로 나감
        if (lang != param && isDetail) {
            cutil.handleUrl(e, urls.depth1, urls.depth2, navigate, setUrl);
        }
        location.reload();
    });
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("hamburger") || targetElement.closest(".hamburger");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".hamburger");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
                setSide(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("header", Object.assign({ className: "pc-header" }, { children: _jsx("div", Object.assign({ className: "navbar__div" }, { children: _jsxs("nav", Object.assign({ className: "navbar" }, { children: [_jsx("div", Object.assign({ className: "navbar__logo", onClick: (e) => cutil.handleUrl(e, `/main${search}`, null, navigate, setUrl) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: _jsx("img", { src: require("/static/img/logo-color.webp"), alt: "logo" }) })) })), _jsx("ul", Object.assign({ className: "navbar__menu" }, { children: (menus) && menus.map((item) => (_jsxs("li", Object.assign({ className: "menu" }, { children: [_jsx("div", Object.assign({ onClick: (e) => cutil.handleUrl(e, item, item.subMenus[0], navigate, setUrl) }, { children: _jsx("a", Object.assign({ href: "#", className: "menu__title" }, { children: item.menuName })) })), _jsx("ul", Object.assign({ className: "navbar__submenu" }, { children: item.subMenus.map((val) => (_jsx("li", Object.assign({ onClick: (e) => cutil.handleUrl(e, item, val, navigate, setUrl) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: val.menuName })) }), val.menuId))) }))] }), item.menuId))) })), _jsx("div", Object.assign({ className: "navbar__lang" }, { children: _jsxs("select", Object.assign({ value: lang, onChange: (e) => langSelect(e) }, { children: [_jsx("option", Object.assign({ value: "KOR" }, { children: "KOR" })), _jsx("option", Object.assign({ value: "ENG" }, { children: "ENG" }))] })) }))] })) })) })), _jsx("header", Object.assign({ className: "mobile-header" }, { children: _jsxs("div", Object.assign({ className: "mobile-navbar" }, { children: [_jsx("div", Object.assign({ className: "mobile-logo" }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => { e.preventDefault(); navigate(`/main?lang=${lang}`); } }, { children: _jsx("img", { src: require("/static/img/logo-color.webp"), alt: "logo" }) })) })), _jsx("button", Object.assign({ id: "openSidebar", className: "hamburger", "aria-label": "\uBA54\uB274 \uC5F4\uAE30", onClick: () => setSide(true) }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, { children: _jsx("path", { d: "M6 36V32H42V36H6ZM6 26V22H42V26H6ZM6 16V12H42V16H6Z", fill: "black" }) })) }))] })) })), _jsxs("aside", Object.assign({ id: "sidebar", className: `sidebar ${side ? "open" : ""}`, "aria-hidden": "true" }, { children: [_jsx("button", Object.assign({ id: "closeSidebar", className: "closebtn", "aria-label": "\uBA54\uB274 \uB2EB\uAE30", onClick: () => setSide(false) }, { children: "\u00D7" })), _jsx("nav", { children: _jsx("ul", { children: (menus) && menus.map((item) => (_jsxs("li", { children: [_jsx("a", Object.assign({ href: "#", className: "main-link", onClick: (e) => cutil.handleUrl(e, item, item.subMenus[0], navigate, setUrl) }, { children: item.menuName })), _jsx("ul", { children: item.subMenus.map((val) => (_jsx("li", Object.assign({ onClick: (e) => cutil.handleUrl(e, item, val, navigate, setUrl) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: val.menuName })) }), "m_" + val.menuId))) })] }, "m_" + item.menuId))) }) })] }))] }));
}
;
